import { API_BASE_URL } from "./api";

// Одно общее SSE-соединение на всё приложение: MapView/LiveView
// смонтированы одновременно (v-show-вкладки в App.vue, никогда не размонтируются),
// поэтому свой EventSource на компонент означал бы несколько лишних открытых
// соединений на вкладку браузера. Сервер шлёт только сигнал "изменилось что-то
// такого типа"; слушатели сами дёргают тот же REST-эндпоинт для рефетча.
type Listener = (data: unknown) => void;

const listeners = new Map<string, Set<Listener>>();
let source: EventSource | null = null;

function ensureConnected() {
    if (source) return;
    source = new EventSource(`${API_BASE_URL}/events/stream`);
    source.onmessage = (ev) => {
        try {
            const message = JSON.parse(ev.data) as { type: string; data: unknown };
            listeners.get(message.type)?.forEach((cb) => cb(message.data));
        } catch {
            // ignore
        }
    };
    // EventSource переподключается сам после сетевой ошибки — обрабатывать не нужно.
}

export function onServerEvent(type: string, cb: Listener): () => void {
    ensureConnected();
    if (!listeners.has(type)) listeners.set(type, new Set());
    listeners.get(type)!.add(cb);
    return () => listeners.get(type)?.delete(cb);
}
